  type GalleryProps = {
    images: string[];
    onSelect: (url:string) =>void;
    current:string;
  }
  
export default function RenderGallery ({images, onSelect, current}: GalleryProps) {
    return (
          <div className  ="gallery">
        {images.map((img, index) => {
        return(
        <img onClick={()=>onSelect(img)} key={index} className="image-gallery" src={img} alt={img + index} style={{
            cursor: "pointer",
            border: current === img ? "2px solid #333" : "1px solid #ccc",
            borderRadius: 6,
            width: 72,
            height: 72,
            objectFit: "cover",
          }}/>
              )
            }
          )
        }
          </div>
    )
  }